import { ComplexEnum } from '../../utils/complexEnum'
import {
  ConcreteTest,
  ConcretePlacement,
  DensityLot,
  DailyInspectionControlPoint,
  DailyInspectionInspection,
  Gradation,
} from './instances'

export type EJReportTypeItem =
  | typeof ConcreteTest
  | typeof ConcretePlacement
  | typeof DensityLot
  | typeof DailyInspectionControlPoint
  | typeof DailyInspectionInspection
  | typeof Gradation

class EJReportTypeEnum extends ComplexEnum<
  'EJReportType',
  EJReportTypeItem,
  EJReportTypeItem['id']
> {
  readonly typename = 'EJReportType'
  get values() {
    return [
      this.ConcreteTest,
      this.ConcretePlacement,
      this.DensityLot,
      this.DailyInspectionControlPoint,
      this.DailyInspectionInspection,
      this.Gradation,
    ]
  }
  get classTypes() {
    return [...new Set(this.map(({ classType }) => classType))]
  }
  readonly ConcreteTest = ConcreteTest
  readonly ConcretePlacement = ConcretePlacement
  readonly DensityLot = DensityLot
  readonly DailyInspectionControlPoint = DailyInspectionControlPoint
  readonly DailyInspectionInspection = DailyInspectionInspection
  readonly Gradation = Gradation
}

export const EJReportType = new EJReportTypeEnum()
